import React, { useState, useEffect } from 'react';
import axios from 'axios'
import { REACT_APP_INSTAGRAM_ACCESS_TOKEN } from '../env';

const SocialFeeds = () => {
    const [posts, setPosts] = useState([])
    useEffect(() => {
        const controller = new AbortController();
        const fetchPosts = async () => {
            try {
                const response = await axios.get(
                    `https://graph.instagram.com/me/media?fields=id,caption,media_type,media_url,permalink,thumbnail_url,timestamp&access_token=${REACT_APP_INSTAGRAM_ACCESS_TOKEN}`,
                    { signal: controller.signal }
                );
                setPosts(response.data.data);
            } catch (error) {
                if (error.name !== "AbortError") {
                    console.error("Error fetching Instagram posts:", error);
                }
            }
        };
        fetchPosts();
        return () => controller.abort();
    }, []);


    return (
        <div className="container mt-2 pb-4 Social-feed" style={{ maxWidth: '1000px' }}>
            <h2
                className="social-feed-title"
                style={{
                    textAlign: "center",
                    color: "#333",
                    marginBottom: "30px",
                    fontWeight: "bold",
                    fontSize: "2.5rem",
                    fontFamily: "'EB Garamond', serif",
                    fontStyle: "italic",
                    letterSpacing: "1.5px",
                }}
            >
                Instagram Highlights
            </h2>

            <div className="row custom-row">
                {posts.slice(0, 8).map((post, index) => (
                    <div
                        className="col-6 col-sm-6 col-md-4 col-lg-3 d-flex justify-content-center"
                        key={index}
                    >
                        <div
                            className="card shadow-sm w-100"
                            style={{
                                borderRadius: '15px',
                                overflow: 'hidden',
                                border: 'none',
                                maxWidth: '100%',
                                margin: '0px',
                            }}
                        >
                            <a
                                href={post.permalink}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <img
                                    src={post.thumbnail_url || post.media_url}
                                    className="card-img-top social-img"
                                    alt="Instagram Post"
                                    loading="lazy"
                                />

                            </a>
                        </div>
                    </div>
                ))}
            </div>

        </div>

    );
};

export default SocialFeeds;
